module.exports = __webpack_public_path__ + "img/add_desktop_4.6b37a5ca.png";